module.exports = __webpack_public_path__ + "static/media/9S.46304258.svg";